export default __webpack_public_path__ + "static/img16-08fca63bfea5c762f023fab9e8762700.png";